module.exports = __webpack_public_path__ + "img/app_logo.b06d691b.png";